<template>
  <v-container fluid>
    <!-- Title -->
    <Title
        title="Lista de consultorios"
        :description="`Registro de ${totalOffices ? totalOffices : ''} consultorios en el sistema`"
    />

    <!-- Search bar -->
    <v-row justify="space-between">
      <v-col cols="12" md="7">
        <v-text-field
            v-model="searchQuery"
            prepend-inner-icon="mdi-magnify"
            label="Buscar"
            outlined
            dense
            clearable
            hide-details
            class="white"
        />
      </v-col>

      <!-- Create button -->
      <v-col cols="12" md="4" xl="3" class="d-flex align-center">
        <v-btn block color="primary" height="40" @click="openDialogCreateOffice">
          <v-icon left>mdi-plus-box</v-icon>
          Registrar consultorio
        </v-btn>
      </v-col>

      <DialogCreateOffice ref="dialogCreateOffice" @office-created="getOffices"/>
    </v-row>

    <!-- Offices -->
    <v-row v-if="offices.length > 0">
      <v-col cols="12" sm="6" md="4" v-for="office in offices" :key="office.id">
        <v-card
            outlined
            elevation="2"
            class="fill-height selectable-card"
            @click="selectOffice(office)"
        >
          <v-card-title>
            <h3>DIETEC {{ office.name }}</h3>
            <v-spacer/>
            <StatusChip :status="office.status" />
          </v-card-title>

          <v-card-subtitle>
            <p class="primary--text mb-0">{{ office.code }}</p>
          </v-card-subtitle>

          <v-card-text>
            <div>
              <v-icon class="me-2">mdi-map-marker</v-icon>
              <span>{{ office.city }}, {{ office.province }}</span>
            </div>

            <div>
              <v-icon class="me-2">mdi-account</v-icon>
              <span>{{
                  office.leader ? office.leader.name : 'Sin dietista líder asignado'
                }}</span>
            </div>

            <div>
              <v-icon class="me-2">mdi-folder-open</v-icon>
              <span>{{ office.totalClients }} expedientes activos</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <DialogEditOffice :originalOffice="selectedOffice" ref="dialogEditOffice" @office-created="getOffices"/>

      <!-- Pagination -->
      <v-col cols="12" class="d-flex justify-center">
        <v-pagination
            v-model="page"
            :length="totalPages"
            @input="getOffices"
        ></v-pagination>
      </v-col>
    </v-row>

    <!-- No content -->
    <v-row v-else-if="!isLoading">
      <v-col cols="12">
        <v-alert
            color="amber"
            icon="mdi-information"
        >
          No se encontraron registros de consultorios.
        </v-alert>
      </v-col>
    </v-row>

    <!-- Loading -->
    <OverlayLoading v-else/>

  </v-container>
</template>

<script lang="ts">
import Vue from "vue";

import OfficeService from "@/services/offices/OfficeService";

import {RequestOfficePage} from "@/services/offices/entities/RequestOfficePage";
import {Office} from "@/services/offices/entities/Office";

import Title from "@/components/Title.vue";
import OverlayLoading from "@/components/OverlayLoading.vue";
import DialogCreateOffice from "@/views/offices/components/DialogCreateOffice.vue";
import DialogEditOffice from "@/views/offices/components/DialogEditOffice.vue";
import StatusChip from "@/components/StatusChip.vue";

export default Vue.extend({
  name: "OfficesList",
  components: {
    StatusChip,
    Title,
    OverlayLoading,
    DialogCreateOffice,
    DialogEditOffice,
  },
  data() {
    return {
      // Offices
      offices: [] as Office[],
      selectedOffice: {} as Office,

      // Loading
      isLoading: false as boolean,

      // Pagination
      page: 1 as number,
      size: 9 as number,
      searchQuery: "" as string,
      totalPages: 0 as number,
      totalOffices: 0 as number,
    };
  },

  watch: {
    searchQuery: {
      handler: function () {
        this.page = 1;
        this.getOffices();
      },
      immediate: false,
    },
  },

  methods: {
    async getOffices() {
      this.isLoading = true;
      try {
        this.offices = [];
        const body: RequestOfficePage = {
          page: this.page - 1,
          size: this.size,
          searchQuery: this.searchQuery,
        }
        const response = await OfficeService.getOfficePage(body);
        this.offices = response.content;
        this.totalOffices = response.totalElements;
        this.totalPages = response.totalPages;
      } finally {
        this.isLoading = false;
      }
    },
    selectOffice(office: Office) {
      this.selectedOffice = office;
      const dialogRef = this.$refs.dialogEditOffice as any;
      dialogRef.dialog = true;
      this.$nextTick(() => {
        dialogRef.getAvailableDieticians();
      })
    },
    openDialogCreateOffice() {
      (this.$refs.dialogCreateOffice as any).dialog = true;
    },
  },

  async created() {
    await this.getOffices();
  }
})
</script>